import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig } from '../../AppConfig';
import { AUTH_CONFIG_IDS } from '../../auth/auth.config';
import { APP_CONFIG } from '../../shared/injectionTokens';

type RequestBody = Record<string, unknown> | null;
type QueryParams = Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;

@Injectable()
export class BobHttpClient {
    protected baseUrl: string;

    constructor(
        private httpClient: HttpClient,
        @Inject(APP_CONFIG) appConfig: AppConfig,
    ) {
        this.baseUrl = appConfig.bobApi.url;
    }

    get<T>(url: string, queryParams?: QueryParams): Observable<T> {
        const httpOptions = this.getHttpOptions(queryParams);
        return this.httpClient.get<T>(`${this.baseUrl}${url}`, httpOptions);
    }

    post<T>(url: string, body: RequestBody, queryParams?: QueryParams): Observable<T> {
        const httpOptions = this.getHttpOptions(queryParams);
        return this.httpClient.post<T>(`${this.baseUrl}${url}`, body, httpOptions);
    }

    put<T>(url: string, body: RequestBody, queryParams?: QueryParams): Observable<T> {
        const httpOptions = this.getHttpOptions(queryParams);
        return this.httpClient.put<T>(`${this.baseUrl}${url}`, body, httpOptions);
    }

    patch<T>(url: string, body: RequestBody, queryParams?: QueryParams): Observable<T> {
        const httpOptions = this.getHttpOptions(queryParams);
        return this.httpClient.patch<T>(`${this.baseUrl}${url}`, body, httpOptions);
    }

    delete<T>(url: string, queryParams?: QueryParams): Observable<T> {
        const httpOptions = this.getHttpOptions(queryParams);
        return this.httpClient.delete<T>(`${this.baseUrl}${url}`, httpOptions);
    }

    private getHttpOptions(queryParams: QueryParams = {}): { headers: HttpHeaders; params: QueryParams } {
        return {
            headers: new HttpHeaders({
                Authorization: `Bearer ${this.getAccessTokenFromLocalStorage()}`,
            }),
            params: queryParams,
        };
    }

    /**
     * Unfortunately, subscribing to this.oidcSecurityService.getAccessToken() does nothing because it does not emit when
     * the access token is renewed. Therefore, we are forced to get it manually from the localStorage
     */
    private getAccessTokenFromLocalStorage(): string {
        const authSessionStr = localStorage.getItem(AUTH_CONFIG_IDS.OWNER);
        if (!authSessionStr) {
            return '';
        }
        const authSession = JSON.parse(authSessionStr) as {
            authnResult: { access_token: string };
        };
        return authSession.authnResult.access_token;
    }
}
